import { Component, ViewChild, OnInit, OnDestroy, Input, EventEmitter, Output, Injector } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { Store } from '@ngrx/store';
import { PermissionSetService, PermissionSetAssigneeTargetService, AssigneeAppletDtoModel } from 'blg-akaun-ts-lib';
import { PermissionFacade } from '../../../../../../../../modules/permission/facades/permission.facade';
import { gridOptionsServerSide, pageFiltering, pageSorting } from '../../../../../../../../listing.utils';
import { PaginationComponent } from '../../../../../../../../utilities/pagination/pagination.component';
import { ViewColumnComponent } from '../../../../../../../../view-column.component';
import { AppConfig } from '../../../../../../../../visa';
import { SubSink } from 'subsink2';
import { PermissionStates } from '../../../../../../permission-controller/root';
import { UserPermSelectors } from '../../../../../../../../modules/permission/user-permissions-controller/selectors';
import { UserPermActions } from '../../../../../../../../modules/permission/user-permissions-controller/actions';
import { TranslateService } from "@ngx-translate/core";
// interface LocalState {
//     deactivateList: boolean;
//     selectedIndex: number;
// }

@Component({
    selector: 'app-user-permission-role-permissionsetlisting',
    templateUrl: './permission-set-listing.component.html',
    styleUrls: ['./permission-set-listing.component.scss']
})

export class UserPermissionRolePermissionSetListingComponent extends ViewColumnComponent implements OnInit, OnDestroy {

    @ViewChild(MatTabGroup, {static:true}) matTab: MatTabGroup;

    @ViewChild(PaginationComponent, {static: false})
    private paginationComponent: PaginationComponent;

    @Input() localState: any;
    @Output() permSetEntity = new EventEmitter();
    @Output() toCreatePermSet = new EventEmitter();

    // protected readonly index = 2;
    // private localState: LocalState;

    // initialise local states
    // readonly localState$ = this.viewColFacade.selectLocalState(this.index);
    // readonly selectedIndex$ = this.componentStore.select(state => (state.localState.selectedIndex));

    // toggleColumn$: Observable<boolean>;
    // searchModel = PermSetListingSearchModel;

    // api visa
    apiVisa = AppConfig.apiVisa;

    // info. about previous local states
    // prevIndex: number;
    // private prevLocalState: any;

    // initial ag grid state
    gridApi;
    gridOptions = gridOptionsServerSide;
    columnsDefs;
    rowSelection = 'single';

    roleGuid: string;

    // subSink is to ensure all subscribe calls are unsubscribed to once the component is destroyed
    private subSink = new SubSink;

    appletGuid = sessionStorage.getItem('appletGuid');

    //translation variable
    permission_set_code_text: string;
    permission_set_name_text: string;

    constructor(
        // private fb: FormBuilder,
        private store: Store<PermissionStates>,
        private viewColFacade: PermissionFacade,
        // private readonly componentStore: ComponentStore<{localState: LocalState}>,
        private permissionSetService: PermissionSetService,
        private permissionSetAssigneeTargetService: PermissionSetAssigneeTargetService,
        private injector: Injector
      ) {
        super();
        const translateService = this.injector.get(TranslateService, null);
        if (translateService) {
          translateService.get('labels').subscribe(res => {
            this.permission_set_code_text = res.permission_set_code;
            this.permission_set_name_text = res.permission_set_name;
          });
        } else {
          // Fallback if translation service is unavailable
          this.permission_set_code_text = 'Permission Set Code';
          this.permission_set_name_text = 'Permission Set Name';
        }
      }

    /**
     * Lifecycle method: Called when component is first initialised.
     */
    ngOnInit(): void {
        // initial configurations for toggle column and local state
        // this.toggleColumn$ = this.viewColFacade.toggleColumn$;
        // this.subSink.sink = this.localState$.subscribe( a => {
        //     this.localState = a;
        //     this.componentStore.setState( {localState: a} );
        // });

        this.columnsDefs = [
            {
                headerName: this.permission_set_code_text,
                field: 'app_perm_set_hdr.code',
                cellStyle: {textAlign: 'left'}
            },
            {
                headerName: this.permission_set_name_text,
                field: 'app_perm_set_hdr.name',
                cellStyle: {textAlign: 'left'}
            }
        ]
    }

    /**
     * This function is called when the user clicks on the Add button in the UI.
     * Will trigger the add component to be shown on the screen.
     *
     */
    onNext() {
      this.toCreatePermSet.emit();
    }

    /**
     * This function is called when AG grid is first initialised and initially
     * set the datasource of the grid.
     *
     * @param params : grid parameters
     */
    onGridReady(params) {
        this.gridApi = params.api;
        this.gridApi.closeToolPanel();

        this.subSink.sink = this.store.select(UserPermSelectors.selectSelectedRole).subscribe(role => {
            console.log("role",role);
            if(role) {
                this.roleGuid = role.app_mst_role.guid.toString();
                console.log("RoleGuid: ",this.roleGuid);

                // let assigneeAppletDto = new AssigneeAppletDtoModel();
                // assigneeAppletDto.assignee_hdr_table = "app_mst_role";
                // assigneeAppletDto.assignee_guid = this.roleGuid;
                // assigneeAppletDto.applet_guid = this.appletGuid;
                // this.store.dispatch(UserPermActions.loadPermissionSetsInit({assigneeAppletDto}));

                const datasource = this.getDatasource();
                this.gridApi.setServerSideDatasource(datasource);
            }
        })

        // refresh AG grid if there has been an update
        this.store.select(UserPermSelectors.selectUpdatePermSetListing).subscribe(x => {
          if (x) {
            if (this.gridApi.getDisplayedRowCount() > 0) {
              this.gridApi.refreshServerSideStore();
            } else {
              this.gridApi.refreshServerSideStore(
                {purge: true}
              )
            }
            this.store.dispatch(UserPermActions.setUpdatePermSetListing({update: false}));
          }
        })
    }

    /**
     * Returns the datasource for the AG grid.
     *
     * @param conditionalCriteria : any custom criteria to search for in the API
     * @returns the datasource
     */
    getDatasource(conditionalCriteria?){
        let offset = 0;
        let limit = this.paginationComponent.rowPerPage;

        // if(!conditionalCriteria) {
        //     conditionalCriteria = [
        //         { columnName: 'calcTotalRecords', operator: '=', value: 'true' },
        //         { columnName: 'assignee_guid', operator: '=', value: this.roleGuid }
        //     ]
        // }

        // console.log("conditionalCriteria(Perm Set List): ", conditionalCriteria);

        // if(conditionalCriteria) {
        //     return {
        //         getRows: grid => {

        //             const sortModel = grid.request.sortModel;
        //             const filterModel = grid.request.filterModel;
        //             const sortOn = pageSorting(sortModel);
        //             const filter = pageFiltering(filterModel);

        //             // only change offset and limit if no filterModel or sortModel is present
        //             if (Object.keys(filterModel).length == 0 && sortModel.length == 0) {
        //                 offset = grid.request.startRow;
        //                 limit = grid.request.endRow - offset;
        //             }

        //             const pagination = new Pagination(offset, limit, conditionalCriteria);
        //             this.subSink.sink = this.permissionSetService.getByCriteria(pagination, this.apiVisa)
        //             .subscribe(a => {
        //                 console.log("a", a);
        //                 console.log("a.data", a.data);
        //                 // put data into the grid
        //                 const data = sortOn(a.data).filter(entity => filter.by(entity));
        //                 const totalRecords = filter.isFiltering ? a.totalRecords : data.length;

        //                 // force pagination to go to first page if filter is applied
        //                 if (this.paginationComponent.currentPage > this.paginationComponent.totalPage.value) { this.paginationComponent.firstPage() }

        //                 grid.successCallback(data, totalRecords);
        //                 this.store.dispatch(UserPermActions.loadPermissionSetSuccess({totalRecords: a.totalRecords}));
        //               }, err => {
        //                 grid.failCallback();
        //                 this.store.dispatch(UserPermActions.loadPermissionSetFailure({error: err.message}));
        //             })
        //         }
        //     }
        // }
        // else {
            return {
                getRows: grid => {

                    const sortModel = grid.request.sortModel;
                    const filterModel = grid.request.filterModel;
                    const sortOn = pageSorting(sortModel);
                    const filter = pageFiltering(filterModel);

                    // only change offset and limit if no filterModel or sortModel is present
                    if (Object.keys(filterModel).length == 0 && sortModel.length == 0) {
                        offset = grid.request.startRow;
                        limit = grid.request.endRow - offset;
                    }

                    let assigneeAppletDto = new AssigneeAppletDtoModel();
                    assigneeAppletDto.assignee_hdr_table = "app_mst_role";
                    assigneeAppletDto.assignee_guid = this.roleGuid;
                    assigneeAppletDto.applet_guid = this.appletGuid;

                    this.subSink.sink = this.permissionSetAssigneeTargetService.permissionSetAssigneeTargetAllocation(assigneeAppletDto, this.apiVisa)
                    .subscribe(a => {
                        console.log("a.data(PermSet): ", a.data);
                        console.log("a.data[offset](PermSet): ", a.data[offset]);
                        // put data into the grid
                        const data = sortOn(a.data).filter(entity => filter.by(entity));
                        const totalRecords = filter.isFiltering ? a.data.length : data.length;

                        console.log("Data: ",data);
                        console.log("Data[offset]: ",data[offset]);
                        console.log("totalRecords: ",totalRecords);
                        // grid.success({
                        //     rowData: data,
                        //     rowCount: totalRecords,
                        // });
                        grid.successCallback(data, totalRecords)

                        // force pagination to go to first page if filter is applied
                        if (this.paginationComponent.currentPage > this.paginationComponent.totalPage.value) { this.paginationComponent.firstPage() }

                        // this.gridApi.forEachNode(a => {
                        //   console.log("foreachnode a:",a);
                        //   console.log("this.localState", this.localState);
                        //   console.log("this.localState.selectedRow", this.localState.selectedRow);
                        //   if(a.data.generic_doc_hdr_guid === this.localState.selectedRow) {
                        //     a.setSelected(true);
                        //   }
                        // });

                      }, err => {
                        // grid.fail();
                        console.log("ERR: ",err);
                        grid.failCallback();
                    })
                }
            }
        // }

    }

  //   /**
  //  * This function is called every time the user clicks on the toggle column
  //  * button. It wil trigger the screen to show either one or two columns at a
  //  * time.
  //  *
  //  * @param e : event
  //  */
  //  onToggle(e: boolean) {
  //   this.viewColFacade.toggleColumn(e);
  // }

  /**
   * This function is called every time the user searches something in the
   * search bar.
   *
   * @param e : the search model
   */
  // onSearch(e: SearchQueryModel) {
  //   console.log("e: ",e);
  //   if (!e.isEmpty) {
  //     const query = e.queryString;
  //     this.searchQuery(query, e.table);
  //   } else {
  //     const datasource = this.getDatasource();
  //     this.gridApi.setServerSideDatasource(datasource);
  //   }
  // }

  /**
   * This function calls the subquery service to get the relevant guids
   * that match the details of the search query and sets the datasource
   * of the AG Grid accordingly.
   *
   * @param query : the search query
   * @param table : the relevant table to search for the search query
   */
  // searchQuery(query: string, table: string) {
  //   // using the subquery service to get the relevant guids
  //   console.log("Query: ", query);
  //   const query$ = this.subQueryService
  //     // TODO: Change master visa to api visa once BLGPD-4272 is complete
  //     .post({ 'subquery': query, 'table': table }, this.apiVisa)
  //     .pipe(
  //       switchMap(resp => of(resp))
  //     );

  //   // if there is response, find the responding vendor guids and set datasource
  //   this.subSink.sink = query$.pipe(
  //     filter(a => a.data.length > 0)
  //   ).subscribe(resp => {
  //       console.log("resp: ", resp);
  //       const criteria = [
  //         { columnName: 'calcTotalRecords', operator: '=', value: 'true' },
  //         { columnName: 'guids', operator: '=', value: resp.data.join(',') },
  //         { columnName: 'applet_guid', operator: '=', value: this.appletGuid }
  //       ]
  //       console.log("resp.data.join(','): ", resp.data.join(','));
  //       console.log("Response");
  //       const datasource = this.getDatasource(criteria);
  //       this.gridApi.setServerSideDatasource(datasource);
  //     })

  //   // if there is no response, clear the table as this means nothing
  //   // in the database matches
  //   this.subSink.sink = query$.pipe(
  //     filter(a => a.data.length === 0)
  //   ).subscribe(_ => {
  //       serverSideClear(this.gridApi)
  //       console.log("No response")
  //   });
  // }

  /**
   * This function is called every time the user clicks on a row in the
   * AG grid.
   *
   * @param entity : the entity on the AG grid that was clicked on
   */
  onRowClicked(entity) {
    this.permSetEntity.emit(entity);
  }


  /**
   * Lifecycle method: Called when component is destroyed.
   */
  ngOnDestroy() {
    this.subSink.unsubscribe();
  }

}
